// CSAT Scheme Assets
export { default as smileyAmber } from "./smiley-amber.svg";
export { default as smileyGreen } from "./smiley-green.svg";
export { default as smileyRed } from "./smiley-red.svg";
export { default as smileyConfoundedFace } from "./smiley-confounded-face.svg";
export { default as smileyConfusedFace } from "./smiley-confused-face.svg";
export { default as smileyNeutralFace } from "./smiley-neutral-face.svg";
export { default as smileyWhiteSmilingFace } from "./smiley-white-smiling-face.svg";
export { default as smileyRelievedFace } from "./smiley-relieved-face.svg";
export { default as smileySlightlyFrowningFace } from "./smiley-slightly-frowning-face.svg";
export { default as smilingFaceWithOpenMouthAndSmilingEyes } from "./smiling-face-with-open-mouth-and-smiling-eyes.svg";

// All Portals
export { default as appInfo } from "./app-info.jpeg";
export { default as invertLogoPng } from "./limitless-logo-invert-solid.png";
export { default as invertLogoWebp } from "./limitless-logo-invert-solid.webp";
export { default as logoPng } from "./limitless-logo-solid-blue-s.png";
export { default as logoWebp } from "./limitless-logo-solid-blue-s.webp";
export { default as loginBackgroundPng } from "./login-background.png";
export { default as loginBackgroundWebp } from "./login-background.webp";
export { default as loginBackground40OpacityPng } from "./login-background-40-opacity.png";
export { default as loginBackground40OpacityWebp } from "./login-background-40-opacity.webp";
export { default as signinBackground } from "./signin-background.png";
export { default as modernLogoLight } from "./modern-logo-light.svg";
export { default as modernLogoDark } from "./modern-logo-dark.svg";
export { default as profilePlaceholderLight } from "./profile-placeholder-light.svg";
export { default as profilePlaceholderDark } from "./profile-placeholder-dark.svg";
export { default as HeadCogPersona } from "./head-cog-persona.svg";
export { default as defaultImage } from "./image.svg";

// Crowd Manager
export { default as linesPng } from "./lines.png";
export { default as paperPng } from "./paper.png";

// Crowd Manager + EWA
export { default as profilePlaceHolder } from "./profile-placeholder.png";
export { default as aiStar } from "./ai-star.svg";

// Crowd Manager + Customer Aspp
export { default as email } from "./email.png";
export { default as expert } from "./expert.png";
export { default as secure } from "./secure.png";

// Customers Apps
export { default as help } from "./help.png";
export { default as customerBackground } from "./customer-background.png";

// Onboarding
export { default as limitlessImage } from "./limitless-image.png";
export { default as propsRewardsImage1 } from "./props-rewards-image1.png";
export { default as propsRewardsImage2 } from "./props-rewards-image2.png";
export { default as propsRewardsImage3 } from "./props-rewards-image3.png";
export { default as stepsImage } from "./steps-image.png";
export { default as limittessSmiley } from "./limitless-smiley.png";
export { default as limitlessSadSmiley } from "./error-smiley.png";